import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from 'src/app/app.module';
import { environment } from 'src/environments/environment';

const win = window as Window & { outdated?: boolean | null };

if (!win.outdated) {
  if (environment.production) {
    enableProdMode();
    if (window) {
      window.console.log = (): void => {};
    }
  }

  platformBrowser()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.log(err));
}
